import { ATTRIBUTION_KEYS, ATTRIBUTION_MAX_LENGTH } from '@/utils/attribution'
import { z } from 'zod'

/** Antwortoptionen auf "Wie sind Sie auf uns aufmerksam geworden?" */
export const REFERRAL_OPTIONS = ['google_search', 'google_ads', 'ai', 'recommendation', 'linkedin', 'other'] as const
export type ReferralOption = (typeof REFERRAL_OPTIONS)[number]

export const attributionSchema = z.object(
  Object.fromEntries(ATTRIBUTION_KEYS.map((key) => [key, z.string().max(ATTRIBUTION_MAX_LENGTH).optional()])) as Record<
    (typeof ATTRIBUTION_KEYS)[number],
    z.ZodOptional<z.ZodString>
  >
)

export type ContactFormValidationKey = 'nameMin' | 'surnameMin' | 'emailRequired' | 'emailInvalid' | 'termsRequired'

// Deutsche Standardmeldungen. Die Serverroute validiert ohne Locale und nutzt
// diese; im Formular kommen die Meldungen aus messages (leadForm.validation),
// damit /en/contact nicht auf Deutsch antwortet.
const DEFAULT_MESSAGES: Record<ContactFormValidationKey, string> = {
  nameMin: 'Der Vorname muss mindestens 2 Zeichen lang sein',
  surnameMin: 'Der Nachname muss mindestens 2 Zeichen lang sein',
  emailRequired: 'Bitte geben Sie eine E-Mail-Adresse ein',
  emailInvalid: 'Ungültige E-Mail-Adresse',
  termsRequired: 'Bitte bestätigen Sie die Datenschutzerklärung'
}

export function createContactFormSchema(t: (key: ContactFormValidationKey) => string = (key) => DEFAULT_MESSAGES[key]) {
  return z.object({
    name: z.string().min(2, { message: t('nameMin') }),
    surname: z.string().min(2, { message: t('surnameMin') }),
    company: z.string().optional(),
    email: z.string().min(1, { message: t('emailRequired') }).email({ message: t('emailInvalid') }),
    userMessage: z.string().optional(),
    service: z.string().optional(),
    // Herkunft: Formularstandort (Prop source), Selbstauskunft und Kampagnendaten
    source: z.string().max(80).optional(),
    referral: z.enum(REFERRAL_OPTIONS).optional(),
    attribution: attributionSchema.optional(),
    // CookieYes-Kategorie "advertisement" beim Absenden; nur damit darf die
    // gclid spaeter an Google Ads uebermittelt werden
    consent_ads: z.boolean().optional(),
    terms: z.boolean().refine((value) => value === true, {
      message: t('termsRequired')
    })
  })
}

export const contactFormSchema = createContactFormSchema()
